import { useEffect, useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';
import { twMerge } from 'tailwind-merge';
import { DebitNoteState, GetDebitNoteListAtom } from '../../store/debitNoteStore';
import DebitNoteFilter from './DebitNoteFilter';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { DebitNote } from './interface/DebiitNote.Interface';
import { formatCustomNumber } from '../../helpers/formatCustomNumber';

// Types

interface StatusInfo {
  [key: string]: any;
}

type StatusType = 'Draft' | 'Approved' | 'Void' | 'Pending Approval' | string;

function DebitNoteScroll() {
  const creditNoteAtom: DebitNoteState = GetDebitNoteListAtom();
  const [tableData, setTableData] = useState<any[]>([]);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { pathname } = useLocation();
  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    setTableData(creditNoteAtom?.debit_note || []);
  }, [creditNoteAtom]);

  const onFilterSelect = (selection: number) => {
    if (selection == 0) {
      setTableData(creditNoteAtom?.debit_note || []);
      return;
    }
    const newList = creditNoteAtom?.debit_note?.filter(item => item?.status_id == selection);
    if (newList?.length) {
      setTableData(newList);
    } else {
      setTableData([]);
    }
  };

  function viewItemDetails(noteId: any) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${noteId}`);
  }

  const manageInvoiceStatus = (status: StatusType) => {
    let defaultClass = 'text-primary';

    switch (status) {
      case 'Draft':
        defaultClass = 'text-danger';
        break;
      case 'Approved':
        defaultClass = 'text-success';
        break;
      case 'Void':
        defaultClass = 'text-warning';
        break;
      case 'Pending Approval':
        defaultClass = 'text-info';
        break;

      default:
        break;
    }

    return <span className={`text-sm font-medium ${defaultClass}`}>{status}</span>;
  };

  return (
    <>
      <DebitNoteFilter bulkActionData={creditNoteAtom?.status_info} onFilterSelect={onFilterSelect} />
      <section className="border-[1px] rounded-lg bg-white border-gray-200 flex flex-col overflow-y-scroll h-[300px] lg:h-[500px] scrollbar-thumb-gray-500 scrollbar-thin scrollbar-track-gray-100 pb-[100px]">
        <div className="border-b-[1px] border-b-gray-300"></div>
        {tableData.map((note: DebitNote, i: number) => {
          return (
            <div
              key={i}
              className={`p-2 lg:p-1 grid grid-cols-2 lg:grid-cols-none border-b-[1px] cursor-pointer border-gray-200 ${
                Number(id) === note?.ref_no ? 'bg-gray-200' : 'hover:bg-gray-100'
              }`}
            >
              <div className="flex flex-row">
                <div className="">
                  {/* <input
                    onChange={(e) => onCheckAll(e, i)}
                    checked={note?.checked ? note?.checked : ""}
                    type="checkbox"
                    className="w-4 h-4 border-[1px] border-gray-300 rounded-sm cursor-pointer"
                  /> */}
                </div>

                <div onClick={() => viewItemDetails(note.ref_no)} className="ml-1">
                  <div className="text-sm font-bold text-gray-700">{note?.debit_note_number}</div>
                  {/* <div className="text-xs text-gray-400 font-semibold italic">
                    {note?.Invoice_Ref_No}
                  </div> */}
                  <div className="text-sm lg:text-xs text-gray-600">{moment(note?.transaction_date).format('DD-MM-YYYY')}</div>
                </div>
              </div>
              <div onClick={() => viewItemDetails(note.ref_no)} className="lg:mt-2 lg:ml-5">
                <div className={twMerge('text-sm font-normal')}>{manageInvoiceStatus(note?.status_name)}</div>

                <div className="mt-[2px] text-sm lg:text-xs font-bold text-gray-700">
                  <CurrencyFormat value={formatCustomNumber(note?.amount)} displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                </div>
              </div>
            </div>
          );
        })}
      </section>
    </>
  );
}

export default DebitNoteScroll;
